import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Space, Spin, Grid } from "antd";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { getAdvanceTransactionApi } from "../../../apiservice/accounts";
import ReportDom from "../../../components/common/ReportDom";
import AdvanceTransactionReceiptBody from "./AdvanceTransactionReceiptBody";

const AdvanceTransactionReceipt = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const reportRef = useRef(null);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Advance Transaction Receipt",
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getAdvanceTransactionApi({ tran_id: id })
      .then((res) => {
        if (res?.data?.length) setData(res.data[0]);
      })
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="p-4">
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          {!screens.xs && "Back"}
        </Button>

        <Space>
          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            disabled={!data}
          >
            {!screens.xs && "Print"}
          </Button>
        </Space>
      </div>

      <Card className="shadow-md rounded-xl">
        {loading ? <Spin /> : data ? <AdvanceTransactionReceiptBody data={data} /> : null}
      </Card>

      {/* PRINT */}
      {data && (
        <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ReportDom
            ref={reportRef}
            mode="receipt-voucher"
            renderTable={() => <AdvanceTransactionReceiptBody data={data} />}
          />
        </div>
      )}
    </div>
  );
};

export default AdvanceTransactionReceipt;
